// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2mN1z","col":"styles_col__1kXqD"};